import { startOfMonth } from 'date-fns'
import differenceInMonths from 'date-fns/differenceInMonths'
import type { TestFunction } from 'yup/lib/util/createValidation'

const dateAfterStartOfAnotherDate =
  (fieldName: string): TestFunction<Date | undefined> =>
  (date, schemas) => {
    if (!date || schemas.parent?.[fieldName] === undefined) {
      return true
    }
    const a = startOfMonth(date)
    const b = startOfMonth(schemas.parent[fieldName] as Date)
    return differenceInMonths(a, b) >= 0
  }

export default dateAfterStartOfAnotherDate
